var mobile = function() {
	// TOGGLE MOBILE NAV
	$('#oc').on('click', function(){
		$('#mnav, #mnav-overlay').fadeToggle(300);
		$('body').toggleClass('oc-open');
	});

	$('#mnav-overlay').on('click', function(){
		$('#oc').trigger('click');
	});

	// RESIZER
	$(window).on('resize', function() {
		setTimeout(function() {
			theOC();
			scrollHandler();
			hideWWbg();
			//resistanceVideo();
		}, 100);
	});

	// FIRST LOAD
	setTimeout(function() {
		theOC();
		scrollHandler();
        mobileBuilder();
        resistanceVideo();
        resistanceButton();
    }, 100);
};


// RESIZE FUNCTION
var theOC = function () {

	var width = $(document).width();
	var height = $(document).height();

	// CONTROL BREAKPOINT
	if (width <= 1160) {
		$('body').addClass('sn');
		disableStickyNav();
	} else {
		$('body').removeClass('sn');
		enableStickyNav();
	}

	// CONTROL BREAKPOINT
	if (width <= 1000) {
		$('#message').removeClass('qa-search');
		$('#qa-search').attr('placeholder', 'Search FAQ\'s before contacting us.');
	} else {
		$('#message').addClass('qa-search');
		$('#qa-search').attr('placeholder', 'Have a question? Type here to search...');
	}

};


// Creates the mobile menu
var mobileBuilder = function () {

    $('#header>div>div').append('<div id="mnav"></div><div id="mnav-overlay"></div>')
    $('#mnav').html($('nav#nav>ul').html());
    $('#mnav').wrapInner('<ul id="mnav-main">');
    $('#mnav').prepend('<div class="lbreak3 op50"></div>');
    //$('#mnav').append('<div class="m-social"><div class="lbreak3 mb0"></div></div>');
    //$('.m-social').append( $('#footer .br .social').clone() );

    $('#mnav a').each(function(index){
        if ( $(this).text() == 'Ultra Worldwide Events') {
			//$(this).parent().remove();;
		}
	});

    $('#mnav').find('.icon').remove();

    $('#mnav ul li.menu-item-has-children>a').append(' <span class="sub-status">+</span>');

    $('#nav ul li.soldout').append(' <span class="menuhoveritem">Sold Out!</span>');
    $('.side-nav ul li.soldout').append(' <span class="menuhoveritem">Sold Out!</span>');

    $('.soldout>a').removeAttr('href');

}

// Controls mobile menus with sub-nav
$(document).on('click', '#header #mnav-main li.menu-item-has-children>a', function(e){

	e.preventDefault();

	if ( $(this).hasClass('open') ) {
		$(this).find('.sub-status').html('+');
		//$(this).find('span.icon-up-dir').addClass('icon-down-dir').removeClass('icon-up-dir');
		$(this).next('ul').slideUp(300);
	} else {
		$(this).find('.sub-status').html('&ndash;');
        //$(this).find('span.icon-down-dir').addClass('icon-up-dir').removeClass('icon-down-dir');
        $(this).next('ul').slideDown(300);
    }

    $(this).toggleClass('open');
});

// Binds the mobile menu close button
$(document).on('click', '#mnav a.btn-close', function(){ $('#oc').trigger('click'); });


var hideWWbg = function() {
    if( !! $(".wwbg").length) {
        setTimeout(function() {
            $('.wwloader').fadeOut(300);
        }, 1500)
        setTimeout(function() {
            $('.wwbg').css({ 'z-index' : '30'});
        }, 100)
    }
}

// Add scrolled class
var scrollHandler = function() {
    if ( ! $('#re-oc').length ) {
        if ($(window).scrollTop() > 10) {
            $('#header, #footer, body').addClass('scrolled');
        }	else {
            $('#header, #footer, body').removeClass('scrolled');
        }
    }
}
$(window).on('scroll', function() {
	scrollHandler();
});

// Sticky Sidebar
var enableStickyNav = function() {
    if( !! $(".side-nav-sticky").length)
    {

        var height = $(window).height();
        var sideheight = $('.side-nav-sticky').height();
        var ch = $('.side-nav-sticky').parent().parent().height();
        var shos = $('.side-nav-sticky').offset();
        var fh = $('#footer').height();
		var hdft = 100 + 60 + 50; // header, spacing, footer
		var tsh = hdft + sideheight;

		if ( !!$(".ticket-meter").length  ) {
            tsh = tsh + 100;
        }
        if ( !!$(".vip-meter").length  ) {
            tsh = tsh + 100;
        }

        /*
		// debugging
		$('.sbd').find('.wh').text(height);
		$('.sbd').find('.sh').text(sideheight);
		$('.sbd').find('.shos').text(shos.top);
		$('.sbd').find('.fh').text(fh);
		$('.sbd').find('.tsh').text(tsh);
		$('.sbd').find('.ch').text(ch);
        */
        var height = $(window).height();
        var sidewidth = $('.side-nav-sticky').width();

        if (height > tsh) {
            $('.side-nav-sticky').css({'width' : sidewidth, 'position' : 'sticky'});
        } else {
            disableStickyNav();
        }

    }

}
var disableStickyNav = function() {

	if( !! $(".side-nav-sticky").length) {
		$('.side-nav-sticky').css({'position' : 'relative'});
	}

}
